export const LISTING_PILL_CLASS = "font-text text-little h-9 gap-125 px-300 py-200 font-normal shadow-none"
export const LISTING_CONTROL_CLASS = `${LISTING_PILL_CLASS} border-line-faint text-fg-heading w-25`
